import { AppConfig } from '../appConfig';
import { ISelectableItem } from '../components/selectableItem/selectableItemConverters';

export async function callApi(method: string, url: string, data?: any) {
	const fullUrl = getFullUrl(url);
	const res = await fetch(fullUrl, {
		method,
		headers: {
			Accept: 'application/json'
		},
		body: JSON.stringify(data)
	})
	return await res.json()
}

export function getFullUrl(url: string): string {
	var fullUrl = '';

	if (AppConfig.GlobalSetting && AppConfig.GlobalSetting.WebAppRoute && AppConfig.GlobalSetting.WebAppRoute !== '') {
		fullUrl = location.protocol + '//' + location.hostname + '/' + AppConfig.GlobalSetting.WebAppRoute + '/' + url;
	} else {
		fullUrl = location.protocol + '//' + location.hostname + '/' + url;
	}
	return fullUrl;
}

export function getContentPath(): string {
	let fullUrl = '';
	let partialUrl = '/Content/';

	if (AppConfig.GlobalSetting && AppConfig.GlobalSetting.WebAppRoute) {
		partialUrl = '/' + AppConfig.GlobalSetting.WebAppRoute + partialUrl;
	}

	fullUrl = location.protocol + '//' + location.hostname + partialUrl;

	return fullUrl;
}

export function getQueryFilter(location: string): SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Filters.DataFilter {
	let result: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Filters.DataFilter = {
		CountryCode: '',
		Culture: AppConfig.GlobalSetting.Culture,
		EnteredVin: '',
		VehicleMarketEntryCode: '',
		FamilyCode: '',
		ImporterBid: AppConfig.GlobalSetting.Bid,
		InfotainmentCode: '',
		ProductionFromCode: '',
		ProductionToCode: ''
	};

	let splits = location.split('?');
	if (splits.length > 1) {
		let search = splits[1];
		let searchSplits = search.split('&');
		if (searchSplits.length > 0) {
			for (var i = 0; i < searchSplits.length; i++) {
				let param = searchSplits[i];
				let paramSplits = param.split('=');
				if (paramSplits.length == 2) {
					let name = paramSplits[0];
					switch (name) {
						case 'infotainment':
							result.InfotainmentCode = paramSplits[1];
							break;
						case 'family':
							result.FamilyCode = paramSplits[1];
							break;
						case 'from':
							result.ProductionFromCode = paramSplits[1];
							break;
						case 'to':
							result.ProductionToCode = paramSplits[1];
							break;
						case 'country':
							result.CountryCode = paramSplits[1];
							break;
					}
				}
			}
		}
	}

	return result;
}

export function getDefaultCountry(countries: ISelectableItem[], importerCountryCode: string) {
	let findCountries = countries.filter((c) => compareCodeWithCountryCode(c.code, importerCountryCode));
	return findCountries && findCountries.length > 0 ? findCountries[0] : null;
}

function compareCodeWithCountryCode(code: string, countryCode: string): boolean {
	let parts = code.split('-');
	return parts[parts.length - 1] === countryCode;
}
